module.exports = __webpack_public_path__ + "static/media/vayz.36f0d3c5.png";